module.exports = require('./helpers/bundle-url').getBundleURL('cUUBm') + "graphics/meta/" + require('./helpers/bundle-manifest').resolve("9R89i");